"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = galleryUrl;
/*
 * @Author: edvardchen
 * @Date:   2016-12-08 20:57:05
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-12-08 21:16:43
 */

/**
 * 图集web地址
 * @param  {String} options.tabId
 * @param  {String} options.tagId
 * @param  {Number} options.docId
 * @param  {String} options.ch
 * @return {String}
 */
function galleryUrl(_ref) {
  var _ref$tabId = _ref.tabId,
      tabId = _ref$tabId === undefined ? 0 : _ref$tabId,
      _ref$tagId = _ref.tagId,
      tagId = _ref$tagId === undefined ? 0 : _ref$tagId,
      docId = _ref.docId,
      ch = _ref.ch;

  var params = tabId + "/" + tagId + "/" + docId + "/0/" + ch;
  return "https://zixun.html5.qq.com/coolread/?ch=" + ch + "#picview/" + params;
}